import { useState } from "react";

const COPIED_FLASH_MS = 1500;

/**
 * Click-to-copy with a short "copied" flash. Failure is deliberately silent:
 * everything this page offers to copy is already on screen and selectable,
 * so a blocked clipboard costs the operator a drag-select, not an error.
 */
export function useCopyToClipboard(value: string) {
  const [copied, setCopied] = useState(false);

  const copy = async () => {
    try {
      await navigator.clipboard.writeText(value);
      setCopied(true);
      setTimeout(() => setCopied(false), COPIED_FLASH_MS);
    } catch {
      /* clipboard blocked — the value is on screen and selectable anyway */
    }
  };

  return { copied, copy };
}
